import React, { useCallback, useEffect } from "react";
import "./ServicePhilosophy.css";
import { hideServicePhilosophy, setPhylosophyData, showHeroBanner } from "../../features/serviceSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ServicePhilosophy = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    service_phylosophy_data
  } = useSelector(state => state.service);
  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_CUSTOM_API+"/service-philosophy"
      );
      dispatch(setPhylosophyData(response.data));

    } catch (error) {
      console.error("API error:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <main className="service-philosophy">
      <button
        type="button"
        className="philosophy-close-btn"
        onClick={(event) => {
          event.stopPropagation();
          dispatch(hideServicePhilosophy());
          dispatch(showHeroBanner());
          navigate("/services");
        }}
      >
        &#10005; Close
      </button>

      {/* Left Title */}
      <div className="sp-left">
        <h1>Service Philosophy</h1>
      </div>

      {/* Right Content */}
      <div className="sp-right">
        <p className="intro" dangerouslySetInnerHTML={{ __html: service_phylosophy_data?.text }}>
        </p>

        {/* <div className="philosophy-section">
          <h3>What is Black Label?</h3>
          <p>
            Black Label membership works the way a private service should.
            Quietly. Precisely. Without ceremony.
          </p>
          <p>
            Membership carries no annual fee. Access stays exclusive to
            Sudsies members and select referrals through luxury boutique
            partners. Once welcomed, your household receives a dedicated
            concierge who learns your standards, your preferences, and your
            state’s cadence, then builds a simple operating rhythm around
            them. A dedicated garment care valet manages all transportation
            of garments and textiles, start to finish, so nothing feels
            handled by committee.
          </p>
        </div> */}

        {/* <div className="philosophy-section">
          <h3>Sense of the Household</h3>
          <p>
            Black Label starts with observation, not assumptions. We learn
            how your household actually runs, who touches what, when
            deadlines matter, and which pieces define your day-to-day
            presentation. We document preferences, build a care playbook,
            and align our cadence with your state’s cadence. The goal is
            simple: the service should feel native, not introduced.
          </p>
        </div> */}

        {/* <div className="philosophy-section">
          <h3>Quiet Presence</h3>
          <p>
            Black Label shows up without noise and delivers results you can
            feel. Timing stays exact. Handling stays disciplined.
            Communication stays minimal but decisive. The work remains out
            of sight, yet the standard remains unmistakable. You get calm
            continuity, not a production.
          </p>
        </div> */}
      </div>
    </main>
  );
};

export default ServicePhilosophy;
